import { Link } from "react-router-dom";
import { ClipboardCheck, Mic, ScrollText } from "lucide-react";
import { useContent } from "@/lib/api";
import { Chip, PageHero, Points, Reveal, Skeleton, Wrap } from "@/night/ui";

export default function Departments() {
  const { data, isLoading } = useContent("departments");
  return (
    <>
      <PageHero en="FACTIONS" ar="أقسام المدينة" desc="كل قسم يعمل بنظام واضح: تدرج وظيفي، تدريب، ومهام يومية داخل المدينة. اختر طريقك." img="/site/sora-lspd-rp.jpg" />
      {isLoading ? <Skeleton /> : (
        <Wrap className="mt-16 space-y-28">
          {data.map((d, i) => (
            <article key={d.slug} className="grid gap-10 lg:grid-cols-2 lg:gap-16" data-testid={`dept-${d.slug}`}>
              <Reveal className={`hud relative aspect-[4/3] overflow-hidden border border-[var(--n-line)] ${i % 2 ? "lg:order-2" : ""}`}>
                <img src={d.image} alt={d.name} className="h-full w-full object-cover transition-transform duration-1000 hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#030509]/80 to-transparent" />
                <span className="f-lat absolute bottom-4 left-6 text-8xl leading-none text-white/10" dir="ltr">{d.tag}</span>
              </Reveal>
              <Reveal delay={0.1} className="flex flex-col justify-center">
                <div className="flex items-center gap-3">
                  <span className="f-mono text-xs text-[var(--n-cyan)]">0{i + 1} / 0{data.length}</span><Chip>{d.tag}</Chip>
                  {d.soon ? <Chip tone="gold">قريباً</Chip> : d.open ? <Chip tone="cyan">التقديم مفتوح</Chip> : <Chip tone="mute">مقفل</Chip>}
                </div>
                <h2 className="f-ar mt-5 text-5xl leading-tight sm:text-6xl">{d.name}</h2>
                <p className="mt-5 leading-8 text-slate-300">{d.description}</p>
                <div className="mt-8 grid gap-8 sm:grid-cols-2">
                  <div><div className="kicker mb-4">المهام</div><Points items={d.duties} /></div>
                  {!!d.requirements?.length && <div><div className="kicker mb-4">أبرز الشروط</div><Points items={d.requirements.slice(0, 4)} /></div>}
                </div>
                <div className="mt-10 flex flex-wrap gap-3">
                  {d.open && !d.soon && <Link to={`/apply/${d.slug}`} className="btn-ice" data-testid={`dept-apply-${d.slug}`}><ClipboardCheck size={16} />قدّم على {d.tag}</Link>}
                  <Link to={`/rules/${d.rulesSlug}`} className="btn-ghost" data-testid={`dept-rules-${d.slug}`}><ScrollText size={16} />القوانين</Link>
                  {d.voiceUrl && <a href={d.voiceUrl} target="_blank" rel="noreferrer" className="btn-ghost" data-testid={`dept-voice-${d.slug}`}><Mic size={16} />المقابلة الصوتية</a>}
                </div>
                {d.soon && <p className="mt-5 text-sm text-amber-300/80">التقديم على هذا القسم لم يُفتح بعد، قريباً.</p>}
              </Reveal>
            </article>
          ))}
        </Wrap>
      )}
    </>
  );
}
